import styled from '@emotion/styled';

const Footer = styled.div`
  padding: 10px;
`;

const ColorBlock = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 10%;
  background-color: ${(props) => props.color};
`;

const EditContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 50px;
  align-items: center;
  justify-content: space-around;
`;

const ColorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export { Footer, ColorBlock, EditContainer, ColorContainer };
